import React from 'react';
import { ModalName } from 'structure/staking/types';
import { StakingPoolCard } from 'structure/staking/containers/StakingPoolCard';
import { StakingPool, StakingProject } from 'api/StakingAPI';

type StakingPoolListProps = {
  pools: StakingPool[];
  project?: StakingProject;
  onOpenModal: (modalName: ModalName, poolId: number) => void;
};

export function StakingPoolCardList({
  pools,
  onOpenModal,
  project,
}: StakingPoolListProps) {
  return (
    <div className='grid grid-cols-1 gap-8 ngmd:grid-cols-2'>
      {pools.map((pool) => (
        <StakingPoolCard
          project={project}
          key={pool.id}
          pool={pool}
          onOpenModal={onOpenModal}
        />
      ))}
    </div>
  );
}
